import { usePropertiesGroups } from './properties-groups';
import { PropertyMarker } from '../components/map-search/property-marker';

export function useMarkers({ properties, zoom, fitBounds, highlightProperties }) {
  let groups = usePropertiesGroups(properties, zoom);

  if (!groups) return [];

  return groups.map(x => (
    <PropertyMarker
      key={`${x.coords[0]}/${x.coords[1]}/${zoom}`}
      {...x}
      fitBounds={fitBounds}
      highlight={highlightProperties}
    />
  ));
}
